import periodList from "./periodList";

export default [periodList];